module.exports = __webpack_public_path__ + "static/img/twjd-sde15.2782dee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde15.png
// module id = 231
// module chunks = 0